export default function inputName(value) {
  return value.toLowerCase().replace(/ /g, '_');
}
